<template>
  <b-container>
    <b-row class="tabviewtable itemstableview">
      <b-col>
        <div v-if="windowWidth > 545">
          <SkeletonTableLoader :columns="headers" :loading="loading" />
          <div v-if="!loading">
            <MasterEmpty :createline="false" v-if="List.length === 0 && !loading && !SearchValue" eheader="Item"
              econtent="Item" eimg="/src/assets/Img/icons/itemmaster.svg" @createNew="IsAdd" />
            <Tableview v-if="List.length !== 0 || SearchValue" :value="List" :paginator="true"
              class="p-datatable-gridlines" :rows="10" :rowHover="true" filterDisplay="menu" :loading="loading1"
              responsiveLayout="scroll" :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters"
              selectionMode="single" @row-click="RowClick" :exceldownload="true" :searchbox="false" :searchbox1="true"
              @search="SearchOption">
              <template v-slot:Add>
                <span v-if="Addstatus">
                  <AddButton @click="IsAdd()" :btnname="$t('btn.plusaddnew')" class="float-rights my-3"></AddButton>
                </span>
                <span>
                  <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                    @click="toggle($event)" />
                </span>
              </template>
              <template v-slot:StockInHand="{ data }">
                {{
                  Math.max(0, (data.StockInHand - (data.PickedQty + data.InTransist))).toFixed(2)
                }}
              </template>
              <template v-slot:exceldownload>
                <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                  PageName="Items Table" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
              </template>
              <template v-slot:AvgLandingCost="{ data }">
                {{ data.AvgLandingCost.toFixed(2) }}
              </template>
              <template v-slot:StockValue="{ data }">
                {{ data.StockValue.toFixed(2) }}
              </template>
              <template v-slot:MRP="{ data }">
                {{ data.MRP.toFixed(2) }}
              </template>
            </Tableview>
          </div>
        </div>

        <div v-if="windowWidth <= 545">
          <MobileLoader v-if="loading" v-for="item in 5" />
          <div v-if="!loading">
            <MasterEmpty :createline="false" v-if="List.length === 0 && !loading" eheader="Item" econtent="Item"
              eimg="/src/assets/Img/icons/itemmaster.svg" @createNew="IsAdd" />
            <MobileViewCardHeader :totalRecords="rowsCount" :state="state">
              <template v-slot:mobilecard>
                <div class="mobile-card" v-for="item in List" @click="RowClick(item)">
                  <div class="d-flex align-items-center gap-1">
                    <p class="light-name">{{ item.Code }} /</p>
                    <p class="light-name1">{{ item.HSNName }}</p>
                  </div>
                  <p class="name">{{ item.ItemName }}</p>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">Stock in Hand :</p>
                    <p class="small-name">{{ item.BranchId }}</p>
                  </div>
                  <div class="d-flex align-items-center gap-2">
                    <p class="light-name">MRP :</p>
                    <p class="small-name">{{ item.MRP }}</p>
                  </div>
                </div>
              </template>
            </MobileViewCardHeader>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
  <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <ItemsRightSidebar :itemId="itemId" v-model:visible="visibleRight" position="right" @close="visibleRight = false"
    v-if="visibleRight" :StockInHand="StockInHand" :ItemObj="ItemObj" />
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  h,
  onMounted,
  computed,
  watch,
  reactive,
  onUnmounted,
} from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";

import Itemcreation from "../../Items/ItemMaster/ItemCreation.vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import axios from "axios";
import service from "../../../../Service/ItemMasService";

import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import ItemsRightSidebar from "../../../../../../modules/Inventory/components/Sidebar/RightSidebar/ItemDetailsRightSidebar.vue";
import ItemStoreMappingService from "../../../../Service/ItemStoreMappingService";
import SupplierCategoryMappingService from "../../../../../../modules/Inventory/Service//SupplierCategoryMappingService";
import SupplierMasterservice from "../../../../../../modules/Inventory/Service/SupplierCategoryMappingService";
import servicesupplier from "../../../../../../modules/Inventory/Service/SupplierMaster";
import itemlistservice from "../../../../../../modules/Inventory/Service/ItemMasService";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";
import debounce from "lodash/debounce";

export default defineComponent({
  components: {
    BacktoPage,
    Headerlayout,
    Itemcreation,
    axios,

    Tableview,
    EditConfirmation,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    ItemsRightSidebar,
    Loader,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
  },
  props: {
    propsParams: {
      type: Object,
    },
    Addstatus: {
      type: Boolean,
      Default: true,
    },
  },
  setup(props, { emit }) {
    debugger;

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    const { t } = useI18n();
    const menu = ref();
    const router = useRouter();
    const routes = useRoute();
    const itemId = ref(0);
    const filter = "";
    const showmodalref = ref(false);
    let loading1 = ref(false);
    let title = "Item Master";
    let List: any = ref([]);
    let CopyList: any = ref([]);
    const visibleRight = ref(false);
    const ColumnVisible = ref(true);
    let StockInHand = ref(0);
    let ItemObj = ref({});
    let ExportOption = ref("");
    let ExportList = ref([]);
    const dataEdit = ref();

    let StoreId = routes.query.Id ?? 0;
    let status = routes.query.Type ?? 0;

    const rowsCount = ref(0);

    let loading = ref(false);

    const itemListed = ref([
      {
        items: [
          {
            label: "Item Tracker",
            visible: true,
            command: async () => {
              router.push("/ItemTrackerView?StoreId=" + StoreId);
            },
          },
        ],
      },
    ]);

    if (status == "SupplierId") {
      ColumnVisible.value = true;
    } else {
      ColumnVisible.value = false;
    }

    const windowWidth = ref(window.innerWidth);

    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    const toggle = (event) => {
      menu.value.toggle(event);
    };

    const ParamValues = ref({
      requestId: "",
      Id: 0,
      Type: 0,
    });

    ParamValues.value.Id = Number(StoreId);
    ParamValues.value.Type = Number(status);

    const state = reactive({
      pagedItems: [], // contains a subset of rows for the current page
      currentPage: 1, // current page number
      pageSize: 10, // number of rows per page
      totalRows: 0, // total number of rows in the database
    });

    const headers = [
      {
        header: t("storetabdetails.items.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },

      {
        header: t("storetabdetails.items.Category"),
        field: "ItemCategoryName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.items.Group"),
        field: "ItemGroupName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.items.SubGroup"),
        field: "ItemSubGroupName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.items.Code"),
        field: "ItemProductId",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.items.Name"),
        field: "ItemName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.items.UOM"),
        field: "UnitName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.items.PurchaseUnitName"),
        field: "PurchaseUnitName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      }, {
        header: t("storetabdetails.items.SalesUnitName"),
        field: "SalesUnitName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.items.AvlQty"),
        field: "StockInHand",
        slot: "StockInHand",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
        hide: ColumnVisible.value,
      },
      {
        header: "Picked Qty",
        field: "PickedQty",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
        hide: ColumnVisible.value,
      },
      {
        header: "InTransistQty",
        field: "InTransist",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
        hide: ColumnVisible.value,
      },
      {
        header: t("storetabdetails.items.ConsumedQty"),
        field: "Consumption",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth d-none",
        hide: ColumnVisible.value,
      },
      {
        header: t("storetabdetails.items.HSN"),
        field: "IntHSNCode",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.items.AvgCost"),
        field: "AvgLandingCost",
        slot: "AvgLandingCost",
        fieldDisplay: "false",
        hide: ColumnVisible.value,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.items.MRP"),
        field: "MRP",
        slot: "MRP",
        fieldDisplay: "false",
        bodyclass: "right_td",
        class: "smallwidth",
        hide: (ColumnVisible.value = true),
      },
      {
        header: t("storetabdetails.items.Value"),
        field: "StockValue",
        slot: "StockValue",
        fieldDisplay: "false",
        bodyclass: "right_td",
        class: "smallwidth",
      },

      // {
      //   header: "Reorder Level",
      //   field: "ReOrderLevel",
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      //   bodyclass: "right_td",
      //   class: "smallwidth",
      //   hide: ColumnVisible.value,
      // },
      {
        header: t("storetabdetails.items.Tax"),
        field: "PurchasePercentage",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.items.Manufacture"),
        field: "ManufactureName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.items.Generic"),
        field: "ItemGenericName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
    ];

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });

    const globalFilterFields = ref(headers.map((col) => col.field));

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Code: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ItemProductId: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      HSNName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ItemName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ManufactureName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      UnitName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ItemCategoryName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemGroupName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemSubGroupName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemGenericName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
    };

    onMounted(() => {
      debugger;
      window.addEventListener("resize", handleResize);

      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    watch(
      () => routes.query.Id,
      (newVal: any) => {
        debugger;
        ParamValues.value.Id = Number(newVal);
        if (status == "SupplierId") {
          ColumnVisible.value = true;
        } else {
          ColumnVisible.value = false;
        }
        IsShow();
      }
    );

    watch(
      [() => state.currentPage, () => state.pageSize],
      async ([pageNum, pageSize]) => {
        debugger;
        await IsShow();
      }
    );
    function onRowClick(event: Event, rowData: any) {
      emit("row-click", rowData);
    }

    async function IsShow() {
      debugger;
      try {
        loading.value = true;

        if (status == "SupplierId") {
          const supplierid1 = ParamValues.value.Id;

          const result1 =
            await SupplierCategoryMappingService.suppliercategorymappinglist();

          let datas = result1["result"].filter(
            (item) => item.SupplierId == supplierid1
          );

          let value1 = datas.map((item) => item.ItemCategoryId);

          const result2 = await itemlistservice.getdata();
          let result3 = result2["result"].filter((item) =>
            value1.includes(item.ItemCategoryId)
          );

          List.value = result3;
          CopyList.value = result3;
        } else {
          const result = await service.ListItemByStoreId(
            ParamValues.value.Id,
            usersData.BranchId,
            usersData.OrganizationId
          );

          List.value = result["result"];
          CopyList.value = result["result"];

          if (result["result"].length > 0) {
            rowsCount.value = result["result"].length;
          }
        }
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    let SearchValue = ref();
    const debouncedSearch = debounce((input) => {
      let regex = new RegExp(input, "i");
      List.value = CopyList.value.filter((item) => {
        return Object.values(item).some((value) => regex.test(String(value)));
      });
    }, 300); // Adjust the delay as needed

    function SearchOption(Input) {
      debugger;
      loading.value = true;
      SearchValue.value = Input;
      debouncedSearch(SearchValue.value);
      loading.value = false;
    }

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;
        if (status == "SupplierId") {
          const supplierid1 = ParamValues.value.Id;
          console.log(supplierid1);
          debugger;
          const result1 =
            await SupplierCategoryMappingService.suppliercategorymappinglist();
          debugger;
          let datas = result1["result"].filter(
            (item) => item.SupplierId == supplierid1
          );
          console.log(datas);
          let value1 = datas.map((item) => item.ItemCategoryId);
          debugger;
          const result2 = await itemlistservice.getdata();
          let result3 = result2["result"].filter((item) =>
            value1.includes(item.ItemCategoryId)
          );
          console.log(result3);
          List.value = result3;
          console.log(List.value);
          ExportList.value = result3["result"].map((item) => {
            const filteredItem = {};

            headers.forEach(({ header, field }) => {
              filteredItem[header] = item[field];
            });

            return filteredItem;
          });
        } else {
          const result = await service.ListItemByStoreId(
            ParamValues.value.Id,
            usersData.BranchId,
            usersData.OrganizationId
          );
          debugger;
          console.log(result);
          List.value = result["result"];
          if (result["result"].length > 0) {
            rowsCount.value = result["result"].length;
          }

          ExportList.value = result["result"].map((item) => {
            const filteredItem = {};

            headers.forEach(({ header, field }) => {
              filteredItem[header] = item[field];
            });

            return filteredItem;
          });
        }

        console.log("ContactTable Data", List.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    function RowClick(event: any) {
      debugger;
      visibleRight.value = true;
      itemId.value = event.data ? event.data.Id : event.Id;
      StockInHand.value = event.data
        ? event.data.StockInHand
        : event.StockInHand;
      ItemObj.value = event.data;
    }

    //Add New PopUp
    const IsAdd = () => {
      router.push({
        path: "/ItemMasterCreation",
      });
    };

    return {
      ItemObj,
      StockInHand,
      ParamValues,
      title,
      headers,
      filter,
      showmodalref,
      showpopModal: showmodalref,
      loading1,
      List,
      filters,
      globalFilterFields,
      filteredColumns,
      IsShow,
      RowClick,
      dataEdit,
      IsAdd,
      visibleRight,
      onRowClick,
      rowsCount,
      state,
      loading,
      itemId,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
      toggle,
      menu,
      itemListed,
      SearchOption,
      SearchValue,
    };
  },
});
</script>

<style lang="scss" scoped>
.mobiledarkname {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: -7px;
}

.mobilelightname {
  font-size: 14px;
  color: #999999;
}

.mobilenrmlname {
  font-size: 14px;
  font-weight: 400;
}
</style>
<style lang="scss">
.itemstableview .p-datatable .p-datatable-thead>tr>th:last-child {
  border-left: 1px solid #e1e1e1 !important;
}
</style>
